const coder = {
  en: {
    coder: {
      labels: {
        name: {
          title: "Name",
          coder: "Coder",
          select: "Select Coder"
        }
      },
      form: {
        create: {
          title: "Add Coder",
        },
      }
    },
  }
}

module.exports.coder = coder;